import { useEffect, useState } from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';

/**
 * Thin banner shown when the device appears to be offline.
 * Uses the web `navigator.onLine` API on web, and is a no-op on native
 * (native connectivity detection requires @react-native-community/netinfo
 * which is not currently installed).
 */
export default function NetworkStatusBanner() {
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const update = () => setIsOffline(!navigator.onLine);
    update();

    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <View style={styles.banner}>
      <Text style={styles.text}>No internet connection</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  banner: {
    backgroundColor: '#b91c1c',
    paddingVertical: 6,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  text: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '600',
  },
});
